import React from 'react';
import WorldHeroRo from '../../components/world/ro/WorldHeroRo';
import WorldTableRo from '../../components/world/ro/WorldTableRo';
import WorldQuantumRo from '../../components/world/ro/WorldQuantumRo';
import WorldCostRo from '../../components/world/ro/WorldCostRo';
import WorldSignalRo from '../../components/world/ro/WorldSignalRo';
import WorldCtaRo from '../../components/world/ro/WorldCtaRo';

const WorldPageRo = () => (
  <main>
    <WorldHeroRo />
    <WorldTableRo />
    <WorldQuantumRo />
    <WorldCostRo />
    <WorldSignalRo />
    <WorldCtaRo />
  </main>
);

export default WorldPageRo;